import React, { FC } from 'react'
import { IonHeader } from '@ionic/react'
import mktController from 'controllers/mktController'
import { useHistoryNew } from '@utils'
import './index.scss'

interface IProps {
  children?: any;
  isShow?: boolean;
  title?: string;
  suffix?: any;
  onClick?: () => void;
}

const BackHeader: FC<IProps> = (props: IProps) => {
  const { children, isShow = true, title, suffix, onClick } = props
  const history = useHistoryNew()
  const onBack = () => {
    if (onClick) {
      onClick()
      return
    }
    mktController.goBack(history)
  }
  return (
    <IonHeader>
      <div className={`mkt-back-header${isShow ? '' : ' mkt-back-header-hide'}`}>
        <div className='header-left'>
          <span data-cypid='mmgHeaderBack' className='back-btn' onClick={onBack}>
            <i className='iconfont icon-chevron-left'></i>
          </span>
          {title && !isShow && <span className='title'>{title}</span>}
        </div>
        {suffix && !isShow && <div className='header-right'> {suffix} </div>}
        {children && isShow && <div className='hide-children'>{children}</div>}
      </div>
    </IonHeader>
  )
}
export default BackHeader
